export const getProgressBarDuration = (bookmarkedTimeInSeconds, totalDurationInSeconds) => {
	return !!bookmarkedTimeInSeconds && !!totalDurationInSeconds
		? Math.ceil((bookmarkedTimeInSeconds / totalDurationInSeconds) * 100)
		: 0
}
